function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M40,8c-12.15,0-22,9.85-22,22v20c0,12.15,9.85,22,22,22s22-9.85,22-22v-20c0-12.15-9.85-22-22-22ZM57,50c0,9.37-7.63,17-17,17s-17-7.63-17-17v-8h6v8c0,6.07,4.93,11,11,11s11-4.93,11-11v-8h6v8ZM37,54v-26h6v26h-6ZM57,38h-6v-8c0-6.07-4.93-11-11-11s-11,4.93-11,11v8h-6v-8c0-9.37,7.63-17,17-17s17,7.63,17,17v8Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/Relevance-active.75a29c4f.svg";
export { SvgComponent as ReactComponent };